const theme = {

    $color_1: `#050505`,
    $color_2: `#FFFFFF`,
    $color_3: `#24272b`,
    $color_4: `#F05A22`,
    $color_5: `#33363A`,
    $color_6: `#373B3F`,
    $color_7: `#050505`,
    $color_8: `#CCCCCC`,
    $color_9: `#24272B`,
    $color_10: `#BCBCBC`,
    $color_11: `#0A0A0A`,
    $color_12: `#3C4045`,
    $color_13: `#707070`,
};


// event list tree in modal
theme['$eventListTreeModalBorderColor'] = theme['$color_1'];
theme['$eventListTreeModalColor'] = theme['$color_2'];
theme['$eventListTreeModalTabBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalScrollbarThumbBackgroundColor'] = theme['$color_4'];
theme['$eventListTreeModalEventDetailsBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalCategoryTabBackgroundColor'] = theme['$color_5'];
theme['$eventListTreeModalMarkActiveEventBackgroundColor'] = theme['$color_4'];
theme['$eventListTreeModalEventBorderBottomColor'] = theme['$color_5'];
theme['$eventListTreeModalSetResultColor'] = theme['$color_4'];
theme['$eventListTreeModalTabSportNameBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalCategoryLevel3BtnsHeaderBackgroundColor'] = theme['$color_6'];
theme['$eventListTreeModalEventDetailsPrematchBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalEventDetailsPrematchBorderColor'] = theme['$color_7'];
theme['$eventListTreeModalTabCategoryNameBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalCategoryLevel3PrematchBtnsHeaderBackgroundColor'] = theme['$color_5'];

// game type group filter with categories
 
theme['$groupFilterCategoryContainerBgColor'] = theme['$color_9'];
theme['$groupFilterBtnFilterBackgroundColor'] = theme['$color_11'];
theme['$groupFilterBtnFilterTextColor'] = theme['$color_8'];
theme['$groupFilterBtnFilterTextActiveColor'] = theme['$color_4'];
theme['$groupFilterCategoryNameColor'] = theme['$color_2'];
theme['$groupFilterCountTextColor'] = theme['$color_10'];
theme['$groupFilterCheckboxBorderColor'] = theme['$color_13'];
theme['$groupFilterCheckboxActiveBorderColor'] = theme['$color_4'];
theme['$groupFilterCheckboxActiveCheckColor'] = theme['$color_2'];
theme['$groupFilterBorderColor'] = theme['$color_11'];
theme['$groupFilterButtonActiveBgColor'] = theme['$color_4'];
theme['$groupFilterButtonTextActiveColor'] = theme['$color_2'];
theme['$groupFilterButtonClearBgColor'] = theme['$color_12'];

export default theme;